import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { About } from "@/components/landing/About";
import { Methodology } from "@/components/landing/Methodology";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer, WhatsAppFloat } from "@/components/landing/Footer";

function App() {
  return (
    <div className="App noise relative min-h-screen overflow-x-hidden bg-[#030712] text-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Methodology />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
